declare namespace $ {

	type $mol_text__text_bog_pazzle_board_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_view__style_bog_pazzle_board_2 = $mol_type_enforce<
		({ 
			'gridTemplateColumns': ReturnType< $bog_pazzle_board['grid_columns'] >,
			'gridTemplateRows': ReturnType< $bog_pazzle_board['grid_rows'] >,
			'aspectRatio': ReturnType< $bog_pazzle_board['grid_ratio'] >,
		}) 
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__attr_bog_pazzle_board_3 = $mol_type_enforce<
		({ 
			'bog_pazzle_assembled': ReturnType< $bog_pazzle_board['merged'] >,
		}) 
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__sub_bog_pazzle_board_4 = $mol_type_enforce<
		ReturnType< $bog_pazzle_board['tiles'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_image__uri_bog_pazzle_board_5 = $mol_type_enforce<
		ReturnType< $bog_pazzle_board['image_uri'] >
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_image__title_bog_pazzle_board_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_image['title'] >
	>
	type $bog_pazzle_board_victory__moves_bog_pazzle_board_7 = $mol_type_enforce<
		ReturnType< $bog_pazzle_board['moves'] >
		,
		ReturnType< $bog_pazzle_board_victory['moves'] >
	>
	type $bog_pazzle_board_victory__time_bog_pazzle_board_8 = $mol_type_enforce<
		ReturnType< $bog_pazzle_board['time'] >
		,
		ReturnType< $bog_pazzle_board_victory['time'] >
	>
	type $bog_pazzle_board_victory__best_bog_pazzle_board_9 = $mol_type_enforce<
		ReturnType< $bog_pazzle_board['best'] >
		,
		ReturnType< $bog_pazzle_board_victory['best'] >
	>
	type $bog_pazzle_board_victory__again_bog_pazzle_board_10 = $mol_type_enforce<
		ReturnType< $bog_pazzle_board['again'] >
		,
		ReturnType< $bog_pazzle_board_victory['again'] >
	>
	type $bog_pazzle_board_victory__home_bog_pazzle_board_11 = $mol_type_enforce<
		ReturnType< $bog_pazzle_board['home'] >
		,
		ReturnType< $bog_pazzle_board_victory['home'] >
	>
	type $bog_pazzle_board_victory__saves_bog_pazzle_board_12 = $mol_type_enforce<
		ReturnType< $bog_pazzle_board['saves'] >
		,
		ReturnType< $bog_pazzle_board_victory['saves'] >
	>
	type $mol_view__style_bog_pazzle_board_13 = $mol_type_enforce<
		({ 
			'maxWidth': ReturnType< $bog_pazzle_board['field_width'] >,
		}) 
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__sub_bog_pazzle_board_14 = $mol_type_enforce<
		ReturnType< $bog_pazzle_board['field_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_pazzle_board_tile__rows_bog_pazzle_board_15 = $mol_type_enforce<
		ReturnType< $bog_pazzle_board['rows'] >
		,
		ReturnType< $bog_pazzle_board_tile['rows'] >
	>
	type $bog_pazzle_board_tile__columns_bog_pazzle_board_16 = $mol_type_enforce<
		ReturnType< $bog_pazzle_board['columns'] >
		,
		ReturnType< $bog_pazzle_board_tile['columns'] >
	>
	type $bog_pazzle_board_tile__image_uri_bog_pazzle_board_17 = $mol_type_enforce<
		ReturnType< $bog_pazzle_board['image_uri'] >
		,
		ReturnType< $bog_pazzle_board_tile['image_uri'] >
	>
	type $bog_pazzle_board_tile__playable_bog_pazzle_board_18 = $mol_type_enforce<
		ReturnType< $bog_pazzle_board['playable'] >
		,
		ReturnType< $bog_pazzle_board_tile['playable'] >
	>
	type $bog_pazzle_board_tile__locked_bog_pazzle_board_19 = $mol_type_enforce<
		ReturnType< $bog_pazzle_board['tile_locked'] >
		,
		ReturnType< $bog_pazzle_board_tile['locked'] >
	>
	type $bog_pazzle_board_tile__piece_bog_pazzle_board_20 = $mol_type_enforce<
		ReturnType< $bog_pazzle_board['tile_piece'] >
		,
		ReturnType< $bog_pazzle_board_tile['piece'] >
	>
	type $bog_pazzle_board_tile__slot_bog_pazzle_board_21 = $mol_type_enforce<
		ReturnType< $bog_pazzle_board['tile_slot'] >
		,
		ReturnType< $bog_pazzle_board_tile['slot'] >
	>
	type $bog_pazzle_board_tile__label_bog_pazzle_board_22 = $mol_type_enforce<
		ReturnType< $bog_pazzle_board['tile_label'] >
		,
		ReturnType< $bog_pazzle_board_tile['label'] >
	>
	type $bog_pazzle_board_tile__selected_bog_pazzle_board_23 = $mol_type_enforce<
		ReturnType< $bog_pazzle_board['tile_selected'] >
		,
		ReturnType< $bog_pazzle_board_tile['selected'] >
	>
	type $bog_pazzle_board_tile__drags_synced_bog_pazzle_board_24 = $mol_type_enforce<
		ReturnType< $bog_pazzle_board['tile_synced'] >
		,
		ReturnType< $bog_pazzle_board_tile['drags_synced'] >
	>
	type $bog_pazzle_board_tile__on_drag_start_bog_pazzle_board_25 = $mol_type_enforce<
		ReturnType< $bog_pazzle_board['tile_press'] >
		,
		ReturnType< $bog_pazzle_board_tile['on_drag_start'] >
	>
	type $bog_pazzle_board_tile__on_drag_bog_pazzle_board_26 = $mol_type_enforce<
		ReturnType< $bog_pazzle_board['tile_drag'] >
		,
		ReturnType< $bog_pazzle_board_tile['on_drag'] >
	>
	type $bog_pazzle_board_tile__on_drag_end_bog_pazzle_board_27 = $mol_type_enforce<
		ReturnType< $bog_pazzle_board['tile_drop'] >
		,
		ReturnType< $bog_pazzle_board_tile['on_drag_end'] >
	>
	export class $bog_pazzle_board extends $mol_view {
		Placeholder( ): $mol_text
		field_width( ): string
		grid_columns( ): string
		grid_rows( ): string
		grid_ratio( ): string
		merged( ): boolean
		tiles( ): readonly(any)[]
		Grid( ): $mol_view
		Peek( ): $mol_image
		Victory( ): $bog_pazzle_board_victory
		field_content( ): readonly(any)[]
		Field( ): $mol_view
		board_content( ): readonly(any)[]
		tile_locked( id: any): boolean
		tile_piece( id: any): number
		tile_slot( id: any): number
		tile_label( id: any): string
		tile_selected( id: any): boolean
		tile_synced( id: any): readonly(any)[]
		tile_press( id: any, next?: any ): any
		tile_drag( id: any, next?: any ): any
		tile_drop( id: any, next?: any ): any
		image_uri( ): string
		rows( ): number
		columns( ): number
		numbers( ): boolean
		playable( ): boolean
		peek( ): boolean
		order( ): readonly(number)[]
		moves( ): number
		time( ): string
		best( ): string
		apply( next?: any ): any
		again( next?: any ): any
		home( next?: any ): any
		saves( next?: any ): any
		sub( ): ReturnType< $bog_pazzle_board['board_content'] >
		Tile( id: any): $bog_pazzle_board_tile
	}
	
}

//# sourceMappingURL=board.view.tree.d.ts.map